const getFlowText = (count: number) => (count === 1 ? 'flow' : 'flows');

export default getFlowText;
